<!-- Start date picker -->
<div class="data-picker-container">
  <mat-form-field>
    <mat-label>{{ "dateRangePicker.startDate" | translate }}</mat-label>
    <input
      matInput
      [matDatepicker]="startDatePicker"
      [min]="minDate"
      [max]="maxDate"
      [value]="initialStartDate"
      (dateChange)="onStartDateSelectedChanged($event)"
      (click)="onStartDateSelectedClicked()" />
    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field>

  <!-- End date picker -->
  <mat-form-field>
    <mat-label>{{ "dateRangePicker.endDate" | translate }}</mat-label>
    <input
      matInput
      [matDatepicker]="endDatePicker"
      [min]="minDate"
      [max]="maxDate"
      [value]="initialEndDate"
      (dateChange)="onEndDateSelectedChanged($event)"
      (click)="onEndDateSelectedClicked()" />
    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>

  <!-- Predefined selectors -->
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    @for (datePeriod of datePeriods; track datePeriod) {
      <button mat-menu-item (click)="onPredefinedDateSlidingClicked(datePeriod)">
        <span>{{ "dateRangePicker." + datePeriod.translationKey | translate }}</span>
      </button>
    }
  </mat-menu>
</div>
